import { useEffect, useState } from "react";

import { InfoModal } from "@newsela/angelou";

import { useStandardsModalContext } from "@/search/NewSearchPageMVP/provider/StandardsModalProvider";
import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import { TOTAL_RESULTS_LIMIT_PER_PAGE } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider/StandardsSearchProvider.constants";
import { modalCss } from "./StandardsModal.styles";
import { StandardsModalFooter } from "./StandardsModalFooter";
import { StandardsModalTabs } from "./StandardsModalTabs";
import { StandardsConfirmAction } from "./shared/StandardsConfirmAction";

interface StandardsModalProps {
  modalProps: {
    isActive: boolean;
  };
  setStandardsModalActive: (val: boolean) => void;
}

export const StandardsModal = ({
  modalProps,
  setStandardsModalActive,
}: StandardsModalProps) => {
  const {
    getters: { isConfirmActionModalOpen },
  } = useStandardsModalContext();

  const { fetchFilteredStandards, allStandardsModalResults } =
    useStandardsSearchContext();
  const [hasFetchedStandards, setHasFetchedStandards] = useState(false);

  useEffect(() => {
    if (
      modalProps.isActive &&
      !hasFetchedStandards &&
      allStandardsModalResults.length !== TOTAL_RESULTS_LIMIT_PER_PAGE
    ) {
      fetchFilteredStandards();
      setHasFetchedStandards(true);
    }
  }, [modalProps.isActive, hasFetchedStandards, allStandardsModalResults]);

  return (
    <>
      <InfoModal
        __cssFor={modalCss(isConfirmActionModalOpen)}
        labelId="filter-by-standards-modal"
        title="Apply standards to filter"
        {...modalProps}
        footer={
          <StandardsModalFooter
            setStandardsModalActive={setStandardsModalActive}
          />
        }
      >
        <StandardsConfirmAction>
          <StandardsModalTabs />
        </StandardsConfirmAction>
      </InfoModal>
    </>
  );
};
